import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector } from 'react-redux';
import { selectExhibitorById, selectExhibitorIds } from 'models/exhibitors';

import Footer from 'components/Footer';
import XtraAppBar from 'components/appbar/XtraAppBar';
import BoothProfileContainer from './BoothProfileContainer';

const RootContainerUI = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: ${({ bgColor }) => (bgColor || '#FFFFFF')};
`;

function RootContainer({ children, ...props }) {
  return (
    <>
      <RootContainerUI {...props}>{children}</RootContainerUI>
    </>
  );
}

RootContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const Container = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 960px) {
    margin-top: 56px;
  }
  .booth-template-wrapper {
    width: 100%;
    background: ${({ hasFunding }) => (hasFunding
    ? 'linear-gradient(180deg, #ACE0F9 -9.96%, #FFF1EB 65.29%, rgba(255, 255, 255, 0) 104.7%)'
    : 'linear-gradient(180deg, #E6D8CC 0%, #FCFBF9 41.63%, #DFE9F3 82.69%, rgba(255, 255, 255, 0) 100%)')};
  }
`;

const EmptyState = styled.div`
  padding: 50px;
  text-align: center;
`;

const LoadingIndicatorContainer = styled.div`
  width: 100%;
  padding: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterWrapper = styled.div`
  padding-top: 20px;
`;

const BoothProfileRootContainer = () => {
  const { boothId } = useParams();
  const boothIds = useSelector(selectExhibitorIds);
  const booth = useSelector((state) => (selectExhibitorById(state, boothId)));
  const { booth_bg_color: boothBgColor } = booth || {};

  useEffect(() => {
    const locale = 'en';
    if (booth) {
      const translation = booth.translations[locale] || {};
      window.trackingEvent('Booth', 'Enter', `${boothId} - ${translation.name}`);
    }
  }, [boothId, booth]);

  const hasFunding = booth ? (booth.tags.find((tag) => tag.includes('Stage of Funding: ')) || false) : false;

  return (
    <RootContainer bgColor={boothBgColor} id="booth-profile-root">
      <XtraAppBar />
      <Container
        hasFunding={hasFunding}
      >
        {
          (boothIds && boothIds.length > 0) ? (
            <>
              {
                booth ? (
                  <BoothProfileContainer
                    booth={booth}
                  />
                ) : (
                  <EmptyState>
                    Booth not found
                  </EmptyState>
                )
              }
            </>
          ) : (
            <LoadingIndicatorContainer>
              <CircularProgress />
            </LoadingIndicatorContainer>
          )
        }
        <FooterWrapper>
          <Footer hashState={`/booth/${boothId}`} />
        </FooterWrapper>
      </Container>
    </RootContainer>
  );
};

export default BoothProfileRootContainer;
